import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { OpenYearlyAction } from './yearly-dialog.action';

/* @ngInject */
export default class CardAddContractDialogController implements ActionHandler {
  private dialogElement;

  protected approve: () => any;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#yearly-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenYearlyAction) {
      this.approve = action.onApprove;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onApprove() {
    this.approve();
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/yearly-info/yearly-dialog.controller.ts